// src/pages/ComingSoon.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slicers/authSlicer";
import { Link } from "react-router-dom";
export default function ComingSoon() {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
 
    // if (user && user.role !== "b2c") {
    //   navigate("/dashboard");
    // }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 dark:from-gray-900 dark:via-indigo-900 dark:to-purple-900">
      <div className="text-center max-w-2xl mx-auto p-8">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-12 border border-gray-100 dark:border-gray-700">
          <div className="mb-8">
            <div className="bg-gradient-to-r from-[#FF8B4C] to-[#FFC857] rounded-full p-4 inline-block mb-6">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                ></path>
              </svg>
            </div>
            <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">
              Coming Soon
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-6">
              We're working hard to bring you an amazing experience!
            </p>
            <p className="text-gray-500 dark:text-gray-400">
              Thank you for signing up. Our customer portal is currently under 
              development and will be available soon. Stay tuned for updates!
            </p>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-center justify-center space-x-4">
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse delay-150"></div>
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse delay-300"></div>
            </div>
             <Link
          onClick={() => dispatch(logout())}
          to="/signin"
          className="flex items-center justify-center gap-3 px-3 py-2 mt-3 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
        >
            <button
          
              className="px-6 py-3 bg-gradient-to-r from-primary to-[#ec68b5] text-white rounded-lg hover:shadow-lg transition-all duration-300"
            >
              Back to signin
            </button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}